document.addEventListener('DOMContentLoaded', () => {
    const menuButton = document.querySelector('.menu_btn');
    const closeButton = document.querySelector('.close_btn');
    const navMenu = document.querySelector('.nav_menu');

    if (menuButton && navMenu) {
        menuButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    if (closeButton && navMenu) {
        closeButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    window.addEventListener("resize", () => { navMenu.classList.remove('active') });

    // Nav submenus (e.g. Tests > Packages) - closed by default, opened by clicking the arrow
    const menuItemsWithChildren = document.querySelectorAll('.nav_items .menu-item-has-children');

    function closeSubmenu(item) {
        item.classList.remove('submenu-open');
        const toggle = item.querySelector(':scope > .submenu-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    menuItemsWithChildren.forEach(item => {
        const link = item.querySelector(':scope > a');
        const submenu = item.querySelector(':scope > .sub-menu');

        if (!link || !submenu) return;

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'submenu-toggle';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Toggle submenu');
        toggle.innerHTML = '<svg width="9" height="6" viewBox="0 0 9 6" fill="none"><path d="M1 1L4.5 5L8 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        link.insertAdjacentElement('afterend', toggle);

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = item.classList.contains('submenu-open');

            menuItemsWithChildren.forEach(otherItem => {
                if (otherItem !== item) closeSubmenu(otherItem);
            });

            item.classList.toggle('submenu-open', !isOpen);
            toggle.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        });
    });

    document.addEventListener('click', (e) => {
        menuItemsWithChildren.forEach(item => {
            if (!item.contains(e.target)) closeSubmenu(item);
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            menuItemsWithChildren.forEach(item => closeSubmenu(item));
        }
    });

    const accordionContainers = document.querySelectorAll('[data-accordion]');
    
    accordionContainers.forEach(container => {
        const accordionItems = container.querySelectorAll('.accordion_item');
    
        accordionItems.forEach(item => {
            const title = item.querySelector('.accordion_title');
    
            if (title) {
                title.addEventListener('click', () => {
                    // Usuwanie klasy 'active' z innych elementów
                    accordionItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
    
                    // Dodanie klasy 'active' do klikniętego elementu
                    item.classList.toggle('active');
                });
            }
        });
    });

    // Tests Block - Nested Accordions
    const testsAccordionContainers = document.querySelectorAll('[data-tests-accordion]');
    
    testsAccordionContainers.forEach(container => {
        // Main category accordions (level 1)
        const categoryItems = container.querySelectorAll('.tests-accordion_item.category-level');
        
        categoryItems.forEach(categoryItem => {
            const categoryTitle = categoryItem.querySelector('.tests-accordion_title.category-title');
            
            if (categoryTitle) {
                categoryTitle.addEventListener('click', (e) => {
                    // Prevent event from bubbling to nested accordions
                    e.stopPropagation();
                    
                    // Close other categories (optional - remove if you want multiple open)
                    categoryItems.forEach(otherCategory => {
                        if (otherCategory !== categoryItem) {
                            otherCategory.classList.remove('active');
                        }
                    });
                    
                    // Toggle current category
                    categoryItem.classList.toggle('active');
                });
            }

            // Nested test accordions (level 2) within this category - only with content
            const testItems = categoryItem.querySelectorAll('.tests-accordion_item.test-level.has-content');
            
            testItems.forEach(testItem => {
                const testTitle = testItem.querySelector('.tests-accordion_title.test-title');
                
                if (testTitle) {
                    testTitle.addEventListener('click', (e) => {
                        // Prevent event from bubbling to parent accordion
                        e.stopPropagation();
                        
                        // Close other tests in the same category
                        testItems.forEach(otherTest => {
                            if (otherTest !== testItem) {
                                otherTest.classList.remove('active');
                            }
                        });
                        
                        // Toggle current test
                        testItem.classList.toggle('active');
                    });
                }
            });
        });
    });

    // Catalogue Block - categories / package list / detail panel
    const catalogueContainers = document.querySelectorAll('[data-catalogue]');

    catalogueContainers.forEach(catalogue => {
        const categoryButtons = catalogue.querySelectorAll('[data-catalogue-category]');
        const listGroups = catalogue.querySelectorAll('[data-catalogue-group]');
        const detailPanels = catalogue.querySelectorAll('[data-catalogue-detail-group]');

        function showPackage(groupIndex, packageIndex) {
            const group = catalogue.querySelector('[data-catalogue-group="' + groupIndex + '"]');

            if (group) {
                group.querySelectorAll('[data-catalogue-package]').forEach(packageButton => {
                    packageButton.setAttribute('aria-pressed', packageButton.dataset.cataloguePackage === String(packageIndex) ? 'true' : 'false');
                });
            }

            detailPanels.forEach(panel => {
                const isMatch = panel.dataset.catalogueDetailGroup === String(groupIndex) && panel.dataset.catalogueDetailPackage === String(packageIndex);
                panel.hidden = !isMatch;
            });
        }

        categoryButtons.forEach(categoryButton => {
            categoryButton.addEventListener('click', () => {
                const groupIndex = categoryButton.dataset.catalogueCategory;

                categoryButtons.forEach(otherButton => {
                    otherButton.setAttribute('aria-selected', otherButton === categoryButton ? 'true' : 'false');
                });

                listGroups.forEach(group => {
                    group.hidden = group.dataset.catalogueGroup !== groupIndex;
                });

                showPackage(groupIndex, 0);
            });
        });

        listGroups.forEach(group => {
            group.querySelectorAll('[data-catalogue-package]').forEach(packageButton => {
                packageButton.addEventListener('click', () => {
                    showPackage(group.dataset.catalogueGroup, packageButton.dataset.cataloguePackage);
                });
            });
        });
    });
});